import mixpanel from "mixpanel-browser";

const MIXPANEL_TOKEN = process.env.REACT_APP_MIXPANEL_TOKEN;


if (MIXPANEL_TOKEN) {
  mixpanel.init(MIXPANEL_TOKEN, {
    api_host: "https://api-eu.mixpanel.com",
    debug: true,
  });
}
/**
 * Identifies a user in Mixpanel and sets their profile properties.
 * @param {Object} user - User data from login
 */
export const identifyUser = (user) => {
  
  if (!user || !user.identifier) return;

  mixpanel.identify(user.identifier);

  const profileProperties = {
    $name: user.name || user.username,
    userType: user.role || user.dashboardType,
    userIdentifier: user.identifier,
    $email: user.email,
  };
  console.log("profileProperties",profileProperties);

  mixpanel.people.set(profileProperties);
};

/**
 * Tracks an event in Mixpanel.
 * @param {string} eventName - Name of the event
 * @param {Object} properties - Custom properties for the event
 */
export const trackEvent = (eventName, properties = {}) => {
 
  const payload = {
    ...properties,
    platform: "Web Dashboard",
  };

  console.log("Sending:", eventName, payload);

  mixpanel.track(
    eventName,
    payload,
    { send_immediately: true }, // force immediate send
    (response) => {
      console.log("Mixpanel Callback Response:", response);
    }
  );
};

/**
 * Resets the Mixpanel user identity (call on logout).
 */
export const resetMixpanel = () => {
  mixpanel.reset();
};

export default mixpanel;